module.exports = __webpack_public_path__ + "static/media/Recargar.974bc929.png";